import type { ReactElement, ReactNode } from "react"
import Tooltip from "@/v2-ui/tooltip"

export type SidebarItemTooltipProps = {
  isEnabled: boolean
  content: ReactNode
  children: ReactElement
}

// Wraps a sidebar entry in its hover tooltip, which is how a minimized
// sidebar still says what each icon is. Passing the entry through untouched
// when there's nothing to show keeps the anchor/button unwrapped in the
// common case.
function SidebarItemTooltip(props: SidebarItemTooltipProps) {
  const { isEnabled, content, children } = props

  if (!isEnabled) return children

  return (
    <Tooltip>
      <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
      <Tooltip.Content side="right">{content}</Tooltip.Content>
    </Tooltip>
  )
}

export default SidebarItemTooltip
